(ns manage.external-templates-page.db
  (:require [common.db.interceptors :refer [forwarded-event]]
            [re-frame.core :as rf]))

(defn context+cfn->evaluate-payload
  [{:keys [width height]} cfn]
  {:addRequestContext false
   :contentFunction cfn
   :context {:creative {:width (int width)
                        :height (int height)}}})

(rf/reg-event-fx :page.external-templates/init
  (fn [{:keys [db]} _]
    (let [stage (get-in db [:context :stage])]
      {:db (cond-> db
             (nil? stage) (assoc-in [:context :stage] "published"))
       :dispatch [:resource.content-function/get-one-with-stage]
       :forward-events [{:register :get-cfn-success
                         :events #{:resource.content-function/get-one-success}
                         :dispatch-to [:page.external-templates/set-cfn]}
                        {:register :get-cfn-failure
                         :events #{:resource.content-function/get-one-failure}
                         :dispatch-to [:page.external-templates/get-cfn-failure]}
                        {:register :evaluate-cfn-success
                         :events #{:resource.content-function/evaluate-success}
                         :dispatch-to [:page.external-templates/evaluate-cfn-success]}]})))

(rf/reg-event-fx :page.external-templates/get-cfn-failure
  [forwarded-event]
  (fn [_ _]
    {:dispatch-later [{:ms 1000
                       :dispatch [:resource.content-function/get-one-with-stage]}]}))

(rf/reg-event-db :page.external-templates/set-cfn
  [forwarded-event]
  (fn [db [_ _ content-function]]
    (assoc-in db [:page.external-templates :content-function] content-function)))

(rf/reg-event-fx :page.external-templates/evaluate-cfn
  [(rf/inject-cofx :sub :page.external-templates/cfn)]
  (fn [{:keys [db]
        :page.external-templates/keys [cfn]} _]
    (let [context (:context db)
          payload (context+cfn->evaluate-payload context cfn)]
      {:dispatch [:resource.content-function/evaluate-for-studio payload]})))

(rf/reg-event-fx :page.external-templates/evaluate-cfn-success
  [forwarded-event]
  (fn [_ [_ content-object]]
    {:dispatch [:iframe/post-content-object {:ids [1]
                                             :content-object content-object}]}))

(rf/reg-fx :page.external-templates/post-message
  (fn [data]
    (.postMessage (.-parent js/window) data "*")))

(rf/reg-event-fx :page.external-templates/handle-message
  (fn [_ [_ event]]
    {:page.external-templates/post-message (.-data event)}))

(rf/reg-sub :page.external-templates/cfn
  (fn [db]
    (get-in db [:page.external-templates :content-function])))
